/**
 * Maison Grès — left sidebar navigation drawer
 */
(function () {
  const OPEN_CLASS = 'maison-nav-open';
  const VISIBLE_CLASS = 'is-open';

  function getDrawer() {
    return document.querySelector('[data-maison-nav-drawer]');
  }

  function setOpen(open) {
    const drawer = getDrawer();
    if (!drawer) return;

    const toggle = document.querySelector('[data-maison-menu-open]');
    document.documentElement.classList.toggle(OPEN_CLASS, open);
    drawer.classList.toggle(VISIBLE_CLASS, open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');

    if (toggle) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    document.body.style.overflow = open ? 'hidden' : '';
  }

  function close() {
    setOpen(false);
  }

  function open() {
    setOpen(true);
  }

  function init() {
    const drawer = getDrawer();
    if (!drawer) return;

    if (drawer.dataset.maisonNavReady === 'true') return;
    drawer.dataset.maisonNavReady = 'true';

    document.querySelectorAll('[data-maison-menu-open]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isOpen = document.documentElement.classList.contains(OPEN_CLASS);
        setOpen(!isOpen);
      });
    });

    document.querySelectorAll('[data-maison-menu-close]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        close();
      });
    });

    if (!window.__maisonNavEscapeBound) {
      window.__maisonNavEscapeBound = true;
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && document.documentElement.classList.contains(OPEN_CLASS)) {
          close();
        }
      });
    }

    drawer.querySelectorAll('.maison-nav-drawer__link').forEach((link) => {
      link.addEventListener('click', close);
    });
  }

  function initReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const sections = document.querySelectorAll(
      '.maison-main > .shopify-section:not(.maison-product-section):not(.maison-cart-section)'
    );
    sections.forEach((section, index) => {
      section.classList.add('maison-reveal');
      section.style.transitionDelay = `${Math.min(index * 0.07, 0.42)}s`;
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.06, rootMargin: '0px 0px -5% 0px' }
    );

    document.querySelectorAll('.maison-reveal').forEach((el) => observer.observe(el));
  }

  function cleanupTagCarousel(wrap) {
    if (!wrap) return;
    if (wrap._tagTimer) {
      window.clearInterval(wrap._tagTimer);
      wrap._tagTimer = null;
    }
    if (wrap._tagMqHandler) {
      if (wrap._tagMqMobile) wrap._tagMqMobile.removeEventListener('change', wrap._tagMqHandler);
      if (wrap._tagReduce) wrap._tagReduce.removeEventListener('change', wrap._tagMqHandler);
      wrap._tagMqHandler = null;
    }
  }

  /**
   * Tagline split by • in theme settings:
   * — Mobile (≤720px): one word at a time between • •
   * — Desktop (721px+): all words visible; staggered entrance + soft highlight rotation
   * — prefers-reduced-motion: static full line
   */
  function initTaglineCarousel() {
    document.querySelectorAll('[data-maison-tag-carousel]').forEach((wrap) => {
      cleanupTagCarousel(wrap);

      const fullEl = wrap.querySelector('.maison-header__topbar-tag-full');
      const desktopEl = wrap.querySelector('.maison-header__topbar-tag-desktop');
      const rotor = wrap.querySelector('.maison-header__topbar-tag-rotor');
      const phrases = Array.from(wrap.querySelectorAll('.maison-header__topbar-tag-phrase'));
      const desktopWords = desktopEl
        ? Array.from(desktopEl.querySelectorAll('.maison-header__topbar-tag-word'))
        : [];
      if (!fullEl || !rotor || phrases.length < 2) return;

      const mqMobile = window.matchMedia('(max-width: 720px)');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      function setDesktopAccent(index) {
        desktopWords.forEach((el, i) => el.classList.toggle('is-accent', i === index));
      }

      function sync() {
        if (wrap._tagTimer) {
          window.clearInterval(wrap._tagTimer);
          wrap._tagTimer = null;
        }

        wrap.classList.remove('maison-header__topbar-tag--entered');

        const mobile = mqMobile.matches;
        const noMotion = reduceMotion.matches;

        if (noMotion) {
          if (desktopEl) desktopEl.setAttribute('hidden', '');
          rotor.setAttribute('hidden', '');
          fullEl.removeAttribute('hidden');
          phrases.forEach((el, i) => el.classList.toggle('is-active', i === 0));
          setDesktopAccent(0);
          return;
        }

        if (mobile) {
          if (desktopEl) desktopEl.setAttribute('hidden', '');
          fullEl.setAttribute('hidden', '');
          rotor.removeAttribute('hidden');

          let idx = phrases.findIndex((el) => el.classList.contains('is-active'));
          if (idx < 0) idx = 0;
          phrases.forEach((el, i) => el.classList.toggle('is-active', i === idx));

          wrap._tagTimer = window.setInterval(() => {
            phrases[idx].classList.remove('is-active');
            idx = (idx + 1) % phrases.length;
            phrases[idx].classList.add('is-active');
          }, 2600);
          return;
        }

        /* Desktop */
        fullEl.setAttribute('hidden', '');
        rotor.setAttribute('hidden', '');
        phrases.forEach((el, i) => el.classList.toggle('is-active', i === 0));

        if (desktopEl && desktopWords.length >= 2) {
          desktopEl.removeAttribute('hidden');
          let accentIdx = desktopWords.findIndex((el) => el.classList.contains('is-accent'));
          if (accentIdx < 0) accentIdx = 0;
          setDesktopAccent(accentIdx);

          requestAnimationFrame(() => {
            wrap.classList.add('maison-header__topbar-tag--entered');
          });

          wrap._tagTimer = window.setInterval(() => {
            desktopWords[accentIdx].classList.remove('is-accent');
            accentIdx = (accentIdx + 1) % desktopWords.length;
            desktopWords[accentIdx].classList.add('is-accent');
          }, 3400);
          return;
        }

        fullEl.removeAttribute('hidden');
      }

      wrap._tagMqMobile = mqMobile;
      wrap._tagReduce = reduceMotion;
      wrap._tagMqHandler = () => sync();

      mqMobile.addEventListener('change', wrap._tagMqHandler);
      reduceMotion.addEventListener('change', wrap._tagMqHandler);

      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
      initReveal();
      initTaglineCarousel();
    });
  } else {
    init();
    initReveal();
    initTaglineCarousel();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const drawer = event.target.querySelector?.('[data-maison-nav-drawer]');
    if (drawer) {
      drawer.dataset.maisonNavReady = '';
    }
    init();
    initReveal();
    initTaglineCarousel();
  });
})();
